export default __webpack_public_path__ + "static/media/Biotif-Light.3b3b0cef.ttf";